import React, { useEffect, useState } from 'react';
import { adminApi } from '../services/api';

function Tile({ label, value, suffix, tone }) {
  return (
    <div className="kpi-tile">
      <div className="kpi-label">{label}</div>
      <div className={`kpi-value ${tone ? `tone-${tone}` : ''}`}>{value == null ? '—' : value}{suffix || ''}</div>
    </div>
  );
}

export default function AdminDashboard() {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      adminApi.metrics()
        .then((m) => { if (!cancelled) { setMetrics(m); setError(null); } })
        .catch((err) => { if (!cancelled) setError(err.message); })
        .finally(() => { if (!cancelled) setLoading(false); });
    };
    load();
    const id = setInterval(load, 60000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (loading) return <div className="card"><span className="spinner" /> Loading metrics…</div>;
  if (error) return <div className="card"><span className="badge danger">Error</span> <p className="muted">{error}</p></div>;

  return (
    <div className="stack-lg">
      <h1 className="h1">Dashboard</h1>
      <div className="kpi-grid">
        <Tile label="Audit completeness (D)" value={metrics.auditCompletenessPct} suffix="%" />
        <Tile label="BCCs received" value={metrics.bccReceivedCount} />
        <Tile label="Marked sent" value={metrics.sentByClientCount} />
        <Tile label="Dispatched" value={metrics.dispatchedCount} />
        <Tile label="Bounce / fail rate" value={metrics.bounceRatePct} suffix="%" />
        <Tile label="Quarantine open" value={metrics.quarantineOpen} />
      </div>
      <div className="card small muted">Metrics refresh every 60 seconds. Window: since go-live.</div>
    </div>
  );
}
